import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type { Segment, SegmentsFilter } from "../@types/services/Segment";
import { api } from "./api";

const API_BASE_URL = "/api/v3/segments";

export const fetchSegments = async ({
  filters,
  ...rest
}: ApiListRequest<SegmentsFilter> = {}): Promise<
  ApiListResponseV3<Segment>
> => {
  const response = await api.get<ApiListResponseV3<Segment>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });

  return response.data;
};
